import React from "react";
import { UserContext } from "../../contexts/UserContext";
import { AccountContext } from "../../contexts/AccountContext";
import User from "./User";
import arrayHelpers from "../../helpers/arrayHelpers";
import HelpIconButton from "../webplayerscrlr/HelpIconButton";
import { SCRLR_CONFIG } from "../webplayerscrlr/config";

const Favorites = props => {
    let { user } = React.useContext(UserContext);
    let { accountUsers } = React.useContext(AccountContext);

    if (!user || !user.favorites || !accountUsers || !accountUsers.length) return null;

    let favorites = user.favorites
        .filter(x => accountUsers.some(ua => ua.accountUserId === x))
        .map(x => {
            return accountUsers.filter(au => au.accountUserId === x)[0];
        })

    arrayHelpers.sort(favorites, "name.full");

    if (!favorites.length) return null;

    return (
        <HelpIconButton
            label={SCRLR_CONFIG.HELP_LABELS.favoriteButton}
            className="favorites-container"
            wrapperStyle={styles.favoritesWrapper}
            iconStyle={styles.favoritesHelpIcon}
        >
            {favorites.map(u => <User key={u.accountUserId} user={u} isFavorite={true} showIcon={true} showLinks={true} />)}
        </HelpIconButton>
    )
}

const styles = {
    favoritesWrapper: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        margin: "0 auto",
        maxWidth: "900px",
        width: "100%",
        paddingLeft: "18px",
    },
    favoritesHelpIcon: {
        position: "static",
        width: "24px",
        height: "24px",
    },
}

export default Favorites;
